let page_schema = {
    "tiers": [
        {
            "name": "Sample Type",
            "type": "checkbox",
            "id": "sample-types",
            "class_name": "tags",
            "child_name": "sample-type",
            "options": [
                {
                    "name": "<i>E. coli</i> Culture",
                    "id": "e-coli-culture"
                },
                {
                    "name": "Yeast Culture",
                    "id": "yeast-culture"
                }
            ]
        },
        {
            "name": "Scale",
            "type": "checkbox",
            "id": "scales",
            "class_name": "tags",
            "child_name": "scale",
            "options": [
                {
                    "name": "Mini",
                    "id": "mini"
                },
                {
                    "name": "Midi",
                    "id": "midi"
                },
                {
                    "name": "Maxi",
                    "id": "maxi"
                },
                {
                    "name": "Giga",
                    "id": "giga"
                }
            ]
        },
        {
            "name": "Culture Processing Volume",
            "type": "checkbox",
            "id": "culture-processing-volumes",
            "class_name": "tags",
            "child_name": "culture-processing-volume",
            "options": [
                {
                    "name": "< 1 ml",
                    "id": "lt-1-ml"
                },
                {
                    "name": "≤ 5 ml",
                    "id": "1-5-ml"
                },
                {
                    "name": "25 ml",
                    "id": "25-ml"
                },
                {
                    "name": "50 ml",
                    "id": "50-ml"
                },
                {
                    "name": "150 ml",
                    "id": "150-ml"
                },
                {
                    "name": "1 - 2.5 L",
                    "id": "1-25-l"
                }
            ]
        },
        {
            "name": "Desired Plasmid Yield",
            "type": "checkbox",
            "id": "desired-plasmid-yields",
            "class_name": "tags",
            "child_name": "desired-plasmid-yield",
            "options": [
                {
                    "name": "≤ 5 µg",
                    "id": "le-5-microg"
                },
                {
                    "name": "≤ 25 µg",
                    "id": "le-25-microg"
                },
                {
                    "name": "≤ 100 µg",
                    "id": "le-100-microg"
                },
                {
                    "name": "≤ 200 µg",
                    "id": "le-200-microg"
                },
                {
                    "name": "≤ 500 µg",
                    "id": "le-500-microg"
                },
                {
                    "name": "≤ 1,000 µg",
                    "id": "le-1000-microg"
                },
                {
                    "name": "≤ 25,000 µg",
                    "id": "le-25000-microg"
                },
                // {
                //     "name": "< 1 ng",
                //     "id": "lt-1-ng"
                // },
                // {
                //     "name": "< 20 µg",
                //     "id": "lt-20-microg"
                // },
                // {
                //     "name": "1 - 5 µg",
                //     "id": "1-5-microg"
                // },
                // {
                //     "name": "1 - 100 µg",
                //     "id": "1-100-microg"
                // },
                // {
                //     "name": "100 - 200 µg",
                //     "id": "100-200-microg"
                // },
                // {
                //     "name": "200 - 400 µg",
                //     "id": "200-400-microg"
                // },
                // {
                //     "name": "600 - 1,200 µg",
                //     "id": "600-1200-microg"
                // },
                // {
                //     "name": "3,000 - 20,000 µg",
                //     "id": "3000-20000-microg"
                // }
            ]
        },
        {
            "name": "Plasmid Size",
            "type": "checkbox",
            "id": "plasmid-sizes",
            "class_name": "tags",
            "child_name": "plasmid-size",
            "options": [
                {
                    "name": "≤ 25 kb",
                    "id": "le-25-kb"
                },
                {
                    "name": "≤ 200 kb",
                    "id": "le-200-kb"
                }
            ]
        },
        {
            "name": "Features",
            "type": "checkbox",
            "id": "features",
            "class_name": "tags",
            "child_name": "feature",
            "options": [
                {
                    "name": "Automatable",
                    "id": "automatable"
                },
                {
                    "name": "Direct Lysis",
                    "id": "direct-lysis"
                },
                {
                    "name": "High-Throughput",
                    "id": "high-throughput"
                },
                {
                    "name": "Suitable for Primary & Sensitive Cell Line Transfections",
                    "id": "suitable-for-primary-and-sensitive-cell-line-transfections"
                },
                {
                    "name": "Suitable for <i>in vivo</i> Applications",
                    "id": "suitable-for-in-vivo-applications"
                },
                {
                    "name": "Transfection-Grade",
                    "id": "transfection-grade"
                },
                {
                    "name": "Vacuum Manifold Compatible",
                    "id": "vacuum-manifold-compatible"
                },
            ]
        },
        {
            "name": "Endotoxin Levels",
            "type": "checkbox",
            "id": "endotoxin-levels",
            "class_name": "tags",
            "child_name": "endotoxin-level",
            "options": [
                {
                    "name": "< 0.1 EU/µg",
                    "id": "lt-001-eu-microg"
                },
                {
                    "name": "≤ 1 EU/µg",
                    "id": "le-1-eu-microg"
                },
                {
                    "name": "≤ 50 EU/µg",
                    "id": "le-50-eu-microg"
                }
            ]
        },
        {
            "name": "Format",
            "type": "checkbox",
            "id": "formats",
            "class_name": "tags",
            "child_name": "format",
            "options": [
                {
                    "name": "Spin-Column",
                    "id": "spin-column"
                },
                {
                    "name": "96-Well Plate",
                    "id": "96-well-plate"
                },
                {
                    "name": "Magnetic Beads (Automatable)",
                    "id": "magnetic-beads"
                },
                {
                    "name": "Alcohol Precipitation",
                    "id": "alcohol-precipitation"
                }
            ]
        }
    ],
    "filters": [],
    "products": {
        "ZymoPURE Plasmid Miniprep Kit": {
          "title": "ZymoPURE Plasmid Miniprep Kit",
          "catalogNumbers": "D4208T, D4209, D4210, D4211, D4212",
          "description": "Rapid spin-column purification of transfection-grade plasmid DNA from up to 5 ml of <i>E. coli</i> culture.",
          "handle": "/products/zymopure-ii-plasmid-miniprep-kit",
          "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4212.webp",
          "generalIndex": "1",
          "id": "zymopure-ii-plasmid-miniprep-kit",
          "tags": [
            "e-coli-culture",
            "mini",
            "1-5-ml",
            "1-100-microg",
            "spin-column",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "vacuum-manifold-compatible",
            "le-200-kb",
            "le-1-eu-microg",
            "le-25-microg",
            "le-25-kb",
            "le-100-microg"
          ],
          "filters": []
        },
        "ZymoPURE - Express Plasmid Midiprep Kit": {
          "title": "ZymoPURE - Express Plasmid Midiprep Kit",
          "catalogNumbers": "D4213",
          "description": "Purify transfection-grade plasmid DNA from 25 ml of <i>E. coli</i> culture without pelleting cells.",
          "handle": "/products/zymopure-express-plasmid-midiprep-kit",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4213_ZymoPURE---Express-Plasmid-Midiprep-Kit.jpg?v=1639434343&width=600",
          "generalIndex": "6",
          "id": "zymopure-express-plasmid-midiprep-kit",
          "tags": [
            "e-coli-culture",
            "midi",
            "25-ml",
            "100-200-microg",
            "spin-column",
            "direct-lysis",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "vacuum-manifold-compatible",
            "le-200-kb",
            "le-1-eu-microg",
            "le-100-microg",
            "le-25-kb",
            "le-200-microg"
          ],
          "filters": []
        },
        "ZymoPURE II Plasmid Midiprep Kit": {
          "title": "ZymoPURE II Plasmid Midiprep Kit",
          "catalogNumbers": "D4200, D4201",
          "description": "Purify up to 1.2 mg of endotoxin-free plasmid DNA in less than 18 minutes using a simple spin-column protocol.",
          "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
          "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4200.webp",
          "generalIndex": "2",
          "id": "zymopure-ii-plasmid-midiprep-kit",
          "tags": [
            "e-coli-culture",
            "midi",
            "50-ml",
            "200-400-microg",
            "spin-column",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "suitable-for-in-vivo-applications",
            "vacuum-manifold-compatible",
            "le-200-kb",
            "lt-001-eu-microg",
            "le-200-microg",
            "le-25-kb",
            "le-500-microg"
          ],
          "filters": []
        },
        "ZymoPURE II Plasmid Maxiprep Kit": {
          "title": "ZymoPURE II Plasmid Maxiprep Kit",
          "catalogNumbers": "D4202, D4203",
          "description": "Purify up to 3.0 mg of endotoxin-free plasmid DNA in less than 18 minutes using a simple spin-column protocol.",
          "handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
          "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4202.webp",
          "generalIndex": "3",
          "id": "zymopure-ii-plasmid-maxiprep-kit",
          "tags": [
            "e-coli-culture",
            "maxi",
            "150-ml",
            "600-1200-microg",
            "spin-column",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "suitable-for-in-vivo-applications",
            "vacuum-manifold-compatible",
            "le-200-kb",
            "lt-001-eu-microg",
            "le-500-microg",
            "le-25-kb",
            "le-1000-microg"
          ],
          "filters": []
        },
        "ZymoPURE II Plasmid Gigaprep Kit": {
          "title": "ZymoPURE II Plasmid Gigaprep Kit",
          "catalogNumbers": "D4204",
          "description": "Rapidly purify up to 25 mg of endotoxin-free plasmid DNA using a simple spin-column protocol.",
          "handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit.jpg?v=1639429337&width=600",
          "generalIndex": "4",
          "id": "zymopure-ii-plasmid-gigaprep-kit",
          "tags": [
            "e-coli-culture",
            "giga",
            "1-25-l",
            "3000-20000-microg",
            "spin-column",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "suitable-for-in-vivo-applications",
            "vacuum-manifold-compatible",
            "le-200-kb",
            "lt-001-eu-microg",
            "le-25-kb",
            "le-25000-microg"
          ],
          "filters": []
        },
        "ZymoPURE 96 Plasmid Miniprep Kit": {
          "title": "ZymoPURE 96 Plasmid Miniprep Kit",
          "catalogNumbers": "D4214, D4215, D4216",
          "description": "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight <i>E. coli</i> culture using a vacuum or centrifuge.",
          "handle": "/products/zymopure-96",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D4214_D4215_ZymoPURE96Kit.jpg?v=1688420296&width=600",
          "generalIndex": "5",
          "id": "zymopure-96",
          "tags": [
            "e-coli-culture",
            "mini",
            "1-5-ml",
            "96-well-plate",
            "transfection-grade",
            "suitable-for-primary-and-sensitive-cell-line-transfections",
            "vacuum-manifold-compatible",
            "automatable",
            "high-throughput",
            "le-200-kb",
            "le-1-eu-microg",
            "le-25-microg",
            "le-25-kb",
            "le-100-microg"
          ],
          "filters": [
            {
              "filter": "high-throughput",
              "index": 0
            }
          ]
        },
        "Zyppy Plasmid Miniprep Kit": {
          "title": "Zyppy Plasmid Miniprep Kit",
          "catalogNumbers": "D4019, D4020, D4036, D4037",
          "description": "Purify ultra-pure plasmid DNA from 600 µl of overnight <i>E. coli</i> culture without pelleting cells.",
          "handle": "/products/zyppy-plasmid-miniprep-kit",
          "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4019.webp",
          "generalIndex": "7",
          "id": "zyppy-plasmid-miniprep-kit",
          "tags": [
            "e-coli-culture",
            "mini",
            "lt-1-ml",
            "1-5-microg",
            "spin-column",
            "direct-lysis",
            "transfection-grade",
            "le-25-kb",
            "le-50-eu-microg",
            "le-5-microg"
          ],
          "filters": []
        },
        "Zyppy-96 Plasmid Kit": {
          "title": "Zyppy-96 Plasmid Kit",
          "catalogNumbers": "D4041, D4042, D4043",
          "description": "High-throughput purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
          "handle": "/products/zyppy-96-plasmid-kit",
          "navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4041.webp",
          "generalIndex": "8",
          "id": "zyppy-96-plasmid-kit",
          "tags": [
            "e-coli-culture",
            "mini",
            "lt-1-ml",
            "1-5-microg",
            "96-well-plate",
            "direct-lysis",
            "transfection-grade",
            "high-throughput",
            "le-25-kb",
            "le-50-eu-microg",
            "le-5-microg"
          ],
          "filters": [
            {
              "filter": "high-throughput",
              "index": 1
            }
          ]
        },
        "Zyppy-96 Plasmid MagBead Miniprep": {
          "title": "Zyppy-96 Plasmid MagBead Miniprep Kit",
          "catalogNumbers": "D4100, D4101, D4102",
          "description": "Automatable purification of ultra-pure plasmid DNA from 750 µl of overnight <i>E. coli</i> culture without pelleting cells.",
          "handle": "/products/zyppy-96-plasmid-magbead-kit",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png?v=1628532412&width=600",
          "generalIndex": "9",
          "id": "zyppy-96-plasmid-magbead-kit",
          "tags": [
            "e-coli-culture",
            "mini",
            "lt-1-ml",
            "1-5-microg",
            "magnetic-beads",
            "direct-lysis",
            "transfection-grade",
            "automatable",
            "high-throughput",
            "le-25-kb",
            "le-50-eu-microg",
            "le-5-microg"
          ],
          "filters": [
            {
              "filter": "high-throughput",
              "index": 2
            }
          ]
        },
        "ZR Plasmid Miniprep - Classic": {
          "title": "ZR Plasmid Miniprep - Classic",
          "catalogNumbers": "D4015, D4016, D4054",
          "description": "Easily purify ultra-pure plasmid DNA from up to 5 ml of overnight <i>E. coli</i> culture using a traditional alkaline lysis spin-column protocol.",
          "handle": "/products/zr-plasmid-miniprep-classic",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg?v=1628532396&width=600",
          "generalIndex": "13",
          "id": "zr-plasmid-miniprep-classic",
          "tags": [
            "e-coli-culture",
            "mini",
            "1-5-ml",
            "lt-20-microg",
            "spin-column",
            "transfection-grade",
            "le-25-kb",
            "le-50-eu-microg",
            "le-25-microg"
          ],
          "filters": []
        },
        "Zymoprep Yeast Plasmid Miniprep I": {
          "title": "Zymoprep Yeast Plasmid Miniprep I",
          "catalogNumbers": "D2001",
          "description": "Simple plasmid DNA isolation by isopropanol precipitation from yeast cultures using Zymolyase and alkaline lysis.",
          "handle": "/collections/zymoprep-yeast-plasmid-miniprep/products/zymoprep-yeast-plasmid-miniprep-i",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit_8b5581ce-6473-43b0-951d-d8f0a01bd259.jpg?v=1628532359&width=600",
          "generalIndex": "10",
          "id": "zymoprep-yeast-plasmid-miniprep-i",
          "tags": [
            "yeast-culture",
            "mini",
            "1-5-ml",
            "lt-1-ng",
            "alcohol-precipitation",
            "le-25-kb",
            "le-200-kb",
            "le-5-microg"
          ],
          "filters": []
        },
        "Zymoprep Yeast Plasmid Miniprep II": {
          "title": "Zymoprep Yeast Plasmid Miniprep II",
          "catalogNumbers": "D2004",
          "description": "Quick spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
          "handle": "/collections/zymoprep-yeast-plasmid-miniprep/products/zymoprep-yeast-plasmid-miniprep-ii",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit_aabbe60a-e5fb-44a8-b7b4-722047f23e24.jpg?v=1628532377&width=600",
          "generalIndex": "11",
          "id": "zymoprep-yeast-plasmid-miniprep-ii",
          "tags": [
            "yeast-culture",
            "mini",
            "1-5-ml",
            "lt-1-ng",
            "spin-column",
            "le-25-kb",
            "le-5-microg"
          ],
          "filters": []
        },
        "Zymoprep-96 Yeast Plasmid Miniprep": {
          "title": "Zymoprep-96 Yeast Plasmid Miniprep Kit",
          "catalogNumbers": "D2005, D2006, D2007",
          "description": "Easy high-throughput spin-column purification of plasmid DNA from yeast cultures using Zymolyase and alkaline lysis.",
          "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit_815aae83-fc83-4806-8e72-654cdf122053.jpg?v=1628532360&width=600",
          "generalIndex": "12",
          "id": "zymoprep-yeast-plasmid-miniprep-ii",
          "tags": [
            "yeast-culture",
            "mini",
            "1-5-ml",
            "lt-1-ng",
            "96-well-plate",
            "high-throughput",
            "le-25-kb",
            "le-5-microg"
          ],
          "filters": [
            {
              "filter": "high-throughput",
              "index": 3
            }
          ]
        },
        "ZR BAC DNA Miniprep Kit": {
          "title": "ZR BAC DNA Miniprep Kit",
          "catalogNumbers": "D4048, D4049",
          "description": "Quickly isolate large constructs (≤ 200 kb) from up to 5 ml of overnight <i>E. coli</i> culture using a spin-column.",
          "handle": "/products/zr-bac-dna-miniprep-kit",
          "navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg?v=1628532399&width=600",
          "generalIndex": "14",
          "id": "zr-bac-dna-miniprep-kit",
          "tags": [
            "e-coli-culture",
            "mini",
            "1-5-ml",
            "1-5-microg",
            "spin-column",
            "le-25-kb",
            "le-200-kb",
            "le-50-eu-microg",
            "le-5-microg",
            "transfection-grade"
          ],
          "filters": []
        }
    }
}